import { render } from "./EcosystemRequestsDetailsPage.vue?vue&type=template&id=12073f23"
import script from "./EcosystemRequestsDetailsPage.vue?vue&type=script&lang=js"
export * from "./EcosystemRequestsDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__